module.exports = __webpack_public_path__ + "static/media/symptomsicon_swollen_knee_uni.9f371e71.svg";